const { getProperty } = require('../PropertyGetter');

const ORIG_THREE_TIER_PRICE_TYPES = [6, 19];
const ORIG_PRICE_TYPES = [7, 10, 8, 16, ...ORIG_THREE_TIER_PRICE_TYPES];
const SALE_ENDS_PRICE_TYPES = [1, 3, 4, 5, 13, 15, 18, 20, 21, 22, 23, 24, 25, 26];

function getActualPrice(priceData, offers) {
  let values;

  if (offers.isWithOffer) {
    values = getProperty(priceData, 'price.finalPrice.values');
  }

  if (!values) {
    const tieredPrice = getProperty(priceData, 'price.tieredPrice', []);

    values = getProperty(tieredPrice, `[${tieredPrice.length - 1}].values`);
  }

  return getProperty(values, '[0]', {});
}

function formatGiftPriceLabel(priceLabel = '') {
  return priceLabel.toLowerCase().startsWith('a ') ? priceLabel.substr(2) : priceLabel;
}

function getSelectedPriceData(selectedPrice, offersData, additionalData) {
  const { priceExpTrt2, priceExpTrt3 } = getProperty(additionalData, 'featureEligible', {});
  const price = getProperty(selectedPrice, 'price', {});
  const {
    finalPrice = {}, tieredPrice = [], priceType = {}, priceTypeId,
  } = price;

  const { onSale, saleEnds, giftPriceLabelToAllUpcs = '' } = priceType;
  const giftpriceLabelFormatted = formatGiftPriceLabel(giftPriceLabelToAllUpcs);

  const isFinalPrice = !!(getProperty(offersData, 'lists.withOffer.length'));
  const isWithOfferPromo = isFinalPrice && finalPrice.promoCode;

  // No 'with offer' promo code
  const promoCodeOffer = getProperty(offersData, 'lists.regularOffers', []).find(el => el.promoCode);
  const promoCodeHeader = promoCodeOffer && !isFinalPrice ? getProperty(promoCodeOffer, 'header') : '';

  const isPromotionWithCode = !!(isFinalPrice || promoCodeOffer);

  // get second tier for 'orig/was/sale' 3 tier price
  const regularPriceTierIndex = ORIG_THREE_TIER_PRICE_TYPES.includes(priceTypeId) ? 1 : 0;
  const regularPriceTier = getProperty(tieredPrice, `[${regularPriceTierIndex}]`, {});
  const salePriceTier = getProperty(tieredPrice, `[${tieredPrice.length - 1}]`, {});
  const lowestSalePriceTier = isFinalPrice ? finalPrice : salePriceTier;

  const isShowRegularPrice = !giftPriceLabelToAllUpcs &&
    (
      (onSale && !promoCodeOffer) ||
      isFinalPrice
    );
  const isShowPriceDetailsLink = onSale || isPromotionWithCode || giftPriceLabelToAllUpcs;

  const isShowPercentOff = !!(priceExpTrt2 && !isPromotionWithCode &&
    ORIG_PRICE_TYPES.includes(priceTypeId) && getProperty(salePriceTier, 'values[0].percentOff[0]'));
  const isShowSaleEnds = !!(priceExpTrt3 && SALE_ENDS_PRICE_TYPES.includes(priceTypeId) && saleEnds);
  const isSaleLabel = !!(onSale && !isFinalPrice && (promoCodeOffer || giftPriceLabelToAllUpcs));
  const isLowestPriceRed = onSale || isFinalPrice;

  salePriceTier.isOverlayPriceStyled = onSale && !isWithOfferPromo;

  return {
    priceType,
    tieredPrice,
    regularPriceTier,
    lowestSalePriceTier,
    giftpriceLabelFormatted,
    promoCodeHeader,
    flags: {
      isShowPercentOff,
      isShowSaleEnds,
      isSaleLabel,
      isShowRegularPrice,
      isLowestPriceRed,
      isWithOfferPromo,
      isShowPriceDetailsLink,
    },
  };
}

module.exports = {
  getActualPrice,
  getSelectedPriceData,
};



// WEBPACK FOOTER //
// /Users/m802941/WebstormProjects/2020/campaigns/shop-the-look-pdp/node_modules/@page/digital-product-ui-mcom/src/js/util/viewState/Price.js